import getConfig from "../configs/config-manager"

const SERVICE_URL_PREFIX=getConfig().SERVICE_URL_PREFIX

export default SERVICE_URL_PREFIX